'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { FlowstackProvider } from '@flowstack/sdk';
import { WalletProvider } from '@flowstack/sdk/wallet';
import { usePrivy } from '@privy-io/react-auth';
import { getFlowstackConfig } from '@/lib/config';

const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID || '';
const WALLETCONNECT_PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '';
const config = getFlowstackConfig();

/**
 * P0-72: Reads Privy state from inside the PrivyProvider tree and passes
 * it to FlowstackProvider for mount-time cross-validation. This is what
 * eliminates the 4-minute 401 storm on cold load when sessionStorage has
 * stale credentials but Privy has no session.
 */
function FlowstackProviderWithPrivy({ children }: { children: React.ReactNode }) {
  const { ready, authenticated } = usePrivy();
  return (
    <FlowstackProvider
      config={config}
      privyAuthState={{ ready, authenticated }}
    >
      {children as any}
    </FlowstackProvider>
  );
}

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <WalletProvider
      privyAppId={PRIVY_APP_ID}
      chain="arbitrum"
      baseUrl={config.baseUrl}
      walletConnectProjectId={WALLETCONNECT_PROJECT_ID}
    >
      <FlowstackProviderWithPrivy>{children}</FlowstackProviderWithPrivy>
    </WalletProvider>
  );
}
